import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <div className="relative min-h-screen bg-obsidian font-body text-cream">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Routes>
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </BrowserRouter>
  );
}
